/* eslint-disable react/no-array-index-key */
import * as S from './styles';

interface LinesLoadingProps {
  lines?: number;
}

const LinesLoading: React.FC<LinesLoadingProps> = ({ lines = 10 }) => (
  <S.Container>
    {Array.from({ length: lines }).map((_, i) => (
      <S.Line key={i} data-testid="line" />
    ))}
  </S.Container>
);

export default LinesLoading;
